import store from "../store";
import { showToast } from "../store/slices/formconfig";
import { API_ENDPOINTS } from "../constants/apiEndpoints";
import { getBlob } from "../config/api";

export const calculateDaysDifference = (dueDateString:any) => {
  // Parse the due date string into a Date object
  const dueDate = new Date(dueDateString);
  const today = new Date();

  // Reset hours, minutes, seconds, and milliseconds for accurate day-to-day comparison
  dueDate.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  // Calculate the time difference in milliseconds
  const timeDifference = dueDate.getTime() - today.getTime();

  // Convert milliseconds to days and round to the nearest whole number
  const daysDifference = Math.round(timeDifference / (1000 * 60 * 60 * 24));

  return daysDifference;
};



export const downloadFile = async (url: string, filename: string) => {
  try {
    const blob = await getBlob(url);
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
    store.dispatch(showToast({ message: 'File downloaded successfully.', type: 'success' }));
  } catch (error) {
    console.error('Download failed:', error);
    store.dispatch(showToast({ message: 'Failed to download the file.', type: 'error' }));
  }
};

export const getFileNameFromUrl = (url: string): string => {
  return url.substring(url.lastIndexOf('/') + 1);
}

export const downloadYearWiseReport = async (year: string | number): Promise<void> => {
  const state: any = store.getState();
  const userId = state?.formConfig?.user?.userId;
  const url = `${API_ENDPOINTS.REPORTS_YEAR_WISE}?year=${year}&userId=${userId}`;
  await downloadFile(url, 'year_wise_report.csv');
};